import '../CsvJsonInfoPages.scss';


function DerivativesAndCodes() {

    const data = [
        { field: 1, description: 'CAP ID (Int)' },
        { field: 2, description: 'CAPCode (Char)' },
        { field: 3, description: 'Manufacturer Code (Int)' },
        { field: 4, description: 'Range Code (Int)' },
        { field: 5, description: 'Model Code (Int)' },
        { field: 6, description: 'Trim Code (Int)' },
        { field: 7, description: 'Derivative Description (Char)' },
        { field: 8, description: 'Date derivative was Introduced (Date)' },
        { field: 9, description: 'Date derivative was Discontinued (Blank if current) (Date)' },
        { field: 10, description: 'Order Number (Int)' },
        { field: 11, description: 'Vehicle Sector (TinyInt)' },
        { field: 12, description: 'Doors (TinyInt)' },
        { field: 13, description: 'Drivetrain (Char)' },
        { field: 14, description: 'Fuel Delivery (Char)' },
        { field: 15, description: 'Transmission (Char)' },
        { field: 16, description: 'Fuel Type (Char)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Derivatives & Codes</h1>
            <p>Provides a list of Derivatives coded by CAP.<br /><br />
                CAP Vehicles are split into the following sections:<br /><br />
                Manufacturer e.g. FORD<br />
                Model Range e.g. MONDEO<br />
                Model e.g. MONDEO SALOON<br />
                <b>Derivative e.g. ZETEC 4DR</b><br />
                Trim e.g. ZETEC
            </p>

            <b>File Naming Convention</b><br />
            <p>The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPDer.txt<br />
                LIGHTS_yyyy-mm-dd_CAPDer.txt<br />
                HEAVIES_yyyy-mm-dd_CAPDer.txt<br />
                BIKES_yyyy-mm-dd_CAPDer.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

{/* NEEDS ADDING IN ONCE PAGES ARE CREATED!!!! */}
            {/* Note: For a breakdown of the CAPCode, see the following file layouts:

            Cars CAPCode Layout

            LIGHTS CAPCode Layout

            HEAVIES CAPCode Layout

            BIKES CAPCode Layout */}



        </div>
    );
}

export default DerivativesAndCodes;
